import React, { useEffect, useState } from 'react';
import CardAccordion from './components/CardAccordion';
import BarChart from './components/BarChart';
import ViewBySelect from './components/ViewBySelect';
import { 
  normalizeBarChart, 
  kFormat, 
  normalizeDataTooltip, 
  getDateRangeQueryString, 
} from './helpers';
import qs from 'qs';
import { client } from './api';
import { tooltips } from './Tooltips';

const options = [
  { value: 'totalTime', label: 'Total Time' },
  { value: 'avgTime', label: 'Average Time' }
]

export default function RepairTime(props){
  const { 
    originalRows, 
    dictionary, 
    dateRange, 
    filters, 
    viewType, 
    isCron,
  } = props;
  const [repairTime, setRepairTime] = useState(null);
  const [viewBy, setViewBy] = useState('totalTime');

  useEffect(()=> {
    if(isCron) return;
    const params = { 
      filters: getDateRangeQueryString(filters), 
      viewBy, 
      viewType, 
    };
    client.get("/analytics/repair-time", { params }).then(({ data }) => {
      const result = data.filter(({ id }) => id !== null);
      setRepairTime(result); 
    })
  }, [filters, viewBy, viewType]);

  if(!repairTime){ return null };
  const lineData = [
    {label: 'Total Repair Time'.translate(), borderColor: '#6D93F7', key: 'total'},
    {label: 'Average Repair Time'.translate(), borderColor: '#EA6FDC', key: 'avg'},
  ];
  const normalizedData = normalizeBarChart(
    repairTime, 
    viewBy, 
    "marked", 
    dictionary, 
    dateRange,
    lineData,
  );
  const legends = [
    {title: 'Total Repair Time'.translate(), color: '#6D93F7', key: 'totalTime'},
    {title: 'Average Repair Time'.translate(), color: '#EA6FDC', key: 'avgTime'},
  ];

  return <CardAccordion
    title={"Repair Time".translate()}
    legends={[
      {title: 'Total Repair Time'.translate(), color: '#6D93F7', },
      {title: 'Average Repair Time'.translate(), color: '#EA6FDC', },
    ]}
    filterForm={
      <ViewBySelect value={viewBy} label={"View By".translate()} onChange={(e) => setViewBy(e.target.value)} options={options}/>
    }
  >
    <BarChart
      optionTooltip={tooltips(
        normalizeDataTooltip(
          repairTime, 
          dateRange, 
          'marked', 
          originalRows, 
          viewBy,
        ), 
        legends, 
        viewBy, 
        viewType,
        filters.dateRange,
        'Repair Time'.translate(),
      )}
      xTickFormat={(value, index)=> `${kFormat(value)} ${'min'.translate()}`} 
      data={normalizedData}/>
  </CardAccordion>
}
